"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchForValidateBalances = exports.getPreferencesSuccessActionWatcher = exports.trackBalanceMismatchPeroidicOnPreferenceSuccess = exports.validateBalances = void 0;
const effects_1 = require("redux-saga/effects");
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const accounts_1 = require("companion-app-components/flux/accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const actions = __importStar(require("companion-app-components/flux/preferences/actions"));
const preferencesSelectors = __importStar(require("companion-app-components/flux/preferences/selectors"));
const datasets_1 = require("companion-app-components/flux/datasets");
const institutionLoginsSelectors = __importStar(require("companion-app-components/flux/institution-logins/institutionLoginsSelectors"));
const selectors_1 = require("data/institutionLogins/selectors");
const transactionsSelectors = __importStar(require("data/transactions/selectors"));
const retrievers_1 = require("data/accountBalances/retrievers");
const selectors_2 = require("data/accountBalances/selectors");
const utils_1 = require("data/accountBalances/utils");
const selectors_3 = require("data/preferences/selectors");
const constants_1 = require("utils/constants");
const constants_2 = require("data/accounts/constants");
const actions_1 = require("data/institutionLogins/actions");
const log = (0, core_1.getLogger)('data/accountBalances/sagas');
let checkedBalances = false;
const createEventObject = (datasetId, account, deltaAmount, institutionLogin, isC2REnabled, isBankPendingTxnsExcluded, extraProps) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return (Object.assign({ datasetId, accountId: account.id, accountName: account.name, accountType: account.type, accountSubType: account.subType, institutionId: (_a = institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.institutionId) !== null && _a !== void 0 ? _a : constants_1.APP_STRING_NOT_APPLICABLE, institutionName: (_b = institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.name) !== null && _b !== void 0 ? _b : 'manual', channel: (_c = institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.channel) !== null && _c !== void 0 ? _c : constants_1.APP_STRING_NOT_APPLICABLE, brandingId: (_d = institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.brandingId) !== null && _d !== void 0 ? _d : constants_1.APP_STRING_NOT_APPLICABLE, aggStatus: (_h = (_g = (_f = (_e = institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.aggregators) === null || _e === void 0 ? void 0 : _e.get) === null || _f === void 0 ? void 0 : _f.call(_e, 0)) === null || _g === void 0 ? void 0 : _g.aggStatus) !== null && _h !== void 0 ? _h : constants_1.APP_STRING_NOT_APPLICABLE, delta: deltaAmount, isC2REnabled, isBankPendingTxnsEnabled: !isBankPendingTxnsExcluded, currentBalanceAsOf: (_j = account.currentBalanceAsOf) !== null && _j !== void 0 ? _j : undefined, currentBalanceAsOfOn: (_k = account.currentBalanceAsOfOn) !== null && _k !== void 0 ? _k : undefined, balanceAsOf: (_l = account.balanceAsOf) !== null && _l !== void 0 ? _l : undefined, balanceAsOfOn: (_m = account.balanceAsOfOn) !== null && _m !== void 0 ? _m : undefined, showRemindersUptoDays: (_o = accounts_1.accountsUtils.getReminderSettingInDays(account.recurringTxn)) !== null && _o !== void 0 ? _o : undefined }, extraProps));
};
const isResetOfBalMismatchPrefNeeded = (deltaAmount, zeroValue, balMismatchPref, account) => {
    var _a, _b;
    return Boolean(deltaAmount === zeroValue &&
        (balMismatchPref === null || balMismatchPref === void 0 ? void 0 : balMismatchPref.byId) &&
        ((_a = balMismatchPref === null || balMismatchPref === void 0 ? void 0 : balMismatchPref.byId[account.id]) === null || _a === void 0 ? void 0 : _a.mismatchAmount) &&
        ((_b = balMismatchPref === null || balMismatchPref === void 0 ? void 0 : balMismatchPref.byId[account.id]) === null || _b === void 0 ? void 0 : _b.mismatchAmount) !== zeroValue);
};
// Check if all resoucess are loaded and available before we start validation for account balances
function* areResoucesReadyToCalculateBalances() {
    const accountsPending = yield (0, effects_1.select)(accounts_1.accountsSelectors.getLoadPending);
    const transactionsPending = yield (0, effects_1.select)(transactionsSelectors.getLoadPending);
    const preferencesPending = yield (0, effects_1.select)(preferencesSelectors.getLoadPending);
    const institutionLoginsPending = yield (0, effects_1.select)(institutionLoginsSelectors.getLoadPending);
    const preferencesLoading = yield (0, effects_1.select)(preferencesSelectors.getIsLoading);
    const accountsLoading = yield (0, effects_1.select)(accounts_1.accountsSelectors.getIsLoading);
    const transactionsLoading = yield (0, effects_1.select)(transactionsSelectors.getIsLoading);
    const institutionLoginsLoading = yield (0, effects_1.select)(institutionLoginsSelectors.getIsLoading);
    return !accountsLoading &&
        !accountsPending &&
        !transactionsLoading &&
        !transactionsPending &&
        !preferencesPending &&
        !preferencesLoading &&
        !institutionLoginsPending &&
        !institutionLoginsLoading;
}
// ====================================================
// VALIDATE BALANCES
function* validateBalances() {
    var _a;
    try {
        const datasetId = yield (0, effects_1.select)(auth_1.authSelectors.getDatasetId);
        const showEvent = (yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlags)).get('flagBalanceMismatchWithEvent');
        const resourcesReady = yield areResoucesReadyToCalculateBalances();
        const datasetsById = yield (0, effects_1.select)(datasets_1.datasetsSelectors.getDatasetsById);
        const isSharedDataset = datasetId && ((_a = datasetsById.get(datasetId)) === null || _a === void 0 ? void 0 : _a.shared);
        if (!isSharedDataset && resourcesReady && !checkedBalances) {
            checkedBalances = true;
            let setPreferenceForBalMismatch = false;
            log.log('VALIDATE BALANCES FOR ALL ACCOUNTS ------ ');
            let balMismatchPref = yield (0, effects_1.select)(preferencesSelectors.getSharedPreferencesByPath, { group: 'dataset', path: ['balanceMismatchPrefs'] });
            const accountsById = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
            const institutionLogins = yield (0, effects_1.select)(selectors_1.getInstitutionLoginsById);
            const runningBalanceExcludeAccountIds = yield (0, effects_1.select)(selectors_3.getRunningBalanceExcludeAccountIds);
            const transactionsByAccountId = yield (0, effects_1.select)(transactionsSelectors.getTransactionsByAccountId, {
                txnTypes: transactionsSelectors.TxnTypes.REGULAR_TXNS | transactionsSelectors.TxnTypes.UNACCEPTED_SCHEDULED_TXNS,
            });
            const periodicEvents = [];
            accountsById.forEach((account) => {
                var _a;
                if (account.type !== constants_2.ACCOUNT_TYPES.INVESTMENT && account.type !== constants_2.ACCOUNT_TYPES.LOAN) {
                    const balanceAsOf = (0, retrievers_1.getBalanceForAccountAtDate)({
                        accountId: account.id,
                        date: account.balanceAsOfOn,
                        balanceType: 'currentBalance',
                    });
                    if (balanceAsOf == null || account.balanceAsOf == null) {
                        return;
                    }
                    const deltaAmount = (Number(balanceAsOf) - Number(account.balanceAsOf)).toFixed(2);
                    const zeroValue = Number(0).toFixed(2);
                    const resetBalMismatchPref = isResetOfBalMismatchPrefNeeded(deltaAmount, zeroValue, balMismatchPref, account);
                    const institutionLogin = account.institutionLoginId ? institutionLogins.get(account.institutionLoginId) : undefined;
                    let extraEventProps;
                    if (deltaAmount !== zeroValue) {
                        const excludePendingTxn = runningBalanceExcludeAccountIds === null || runningBalanceExcludeAccountIds === void 0 ? void 0 : runningBalanceExcludeAccountIds.includes(account.id);
                        extraEventProps = {
                            includePendingTxnInBalances: !excludePendingTxn,
                            txnCount: (0, selectors_2.getBalanceContributingTxnCount)(account, transactionsByAccountId.get(account.id), excludePendingTxn),
                        };
                    }
                    if (showEvent && deltaAmount !== zeroValue) {
                        const oldEvent = createEventObject(datasetId, account, deltaAmount, institutionLogin, account.isC2REnabled, account.isBankPendingTxnsExcluded, extraEventProps);
                        log.log('Balance Event Sent: ', oldEvent);
                        core_1.tracker.track(core_1.tracker.events.accountBalanceMismatch, oldEvent);
                    }
                    if ((deltaAmount !== zeroValue && deltaAmount !== ((_a = balMismatchPref === null || balMismatchPref === void 0 ? void 0 : balMismatchPref.byId[account.id]) === null || _a === void 0 ? void 0 : _a.mismatchAmount)) || resetBalMismatchPref) {
                        balMismatchPref = (0, utils_1.initBalMismatchPrefs)(account.id, deltaAmount, balMismatchPref);
                        setPreferenceForBalMismatch = true;
                        // Periodic event need also be be sent when resetBalMismatchPref to track the fixing ratios
                        if (showEvent && !resetBalMismatchPref) {
                            const event = createEventObject(datasetId, account, deltaAmount, institutionLogin, account.isC2REnabled, account.isBankPendingTxnsExcluded, extraEventProps);
                            log.log('New Balance Mismatch Event Sent: ', event);
                            periodicEvents.push(event);
                        }
                    }
                }
            });
            if (setPreferenceForBalMismatch) {
                const prefObj = {
                    section: 'shared',
                    group: 'dataset',
                    preference: { balanceMismatchPrefs: balMismatchPref },
                };
                // Pass this meta information so we could confirm the put call is from accountBalanceMismatch
                // and pass mixpanel events so they can be sent on preference success
                const meta = {
                    context: 'setBalanceMismatchPeriodicPreferences',
                    trackEvents: periodicEvents,
                };
                yield (0, effects_1.put)(actions.setPreference(prefObj, meta));
            }
        }
    }
    catch (error) {
        log.error('Error in validateBalances:', error);
    }
}
exports.validateBalances = validateBalances;
function* trackBalanceMismatchPeroidicOnPreferenceSuccess(action) {
    var _a, _b, _c;
    if (((_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.context) === 'setBalanceMismatchPeriodicPreferences') {
        (_c = (_b = action === null || action === void 0 ? void 0 : action.meta) === null || _b === void 0 ? void 0 : _b.trackEvents) === null || _c === void 0 ? void 0 : _c.forEach((event) => core_1.tracker.track(core_1.tracker.events.accountBalanceMismatchPeriodic, event));
    }
}
exports.trackBalanceMismatchPeroidicOnPreferenceSuccess = trackBalanceMismatchPeroidicOnPreferenceSuccess;
// ====================================================
// ACTION WATCHERS to trigger SAGAS calls
function* getPreferencesSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.setPreferenceSuccess, trackBalanceMismatchPeroidicOnPreferenceSuccess);
}
exports.getPreferencesSuccessActionWatcher = getPreferencesSuccessActionWatcher;
function* watchForValidateBalances() {
    yield (0, effects_1.takeEvery)([
        accounts_1.accountsActions.getAccountsSuccess,
        transactions_1.transactionsActions.getTransactionsSuccess,
        actions_1.getInstitutionLoginsSuccess,
    ], validateBalances);
}
exports.watchForValidateBalances = watchForValidateBalances;
// ====================================================
// EXPORTS
exports.default = [
    watchForValidateBalances,
    getPreferencesSuccessActionWatcher,
];
